const OrganizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": "https://onbbits.io/#organization",

  "name": "ONBBITS",

  "url": "https://onbbits.io/",

  "description":
    "ONBBITS is a WhatsApp automation platform for sales, support, and customer engagement, built to help businesses grow through conversations.",

  "logo": {
    "@type": "ImageObject",
    "url": "https://onbbits.io/logo.svg"
  },

  "email": "info@onbbits.io",

  "telephone": "+91 97270 77732",

  "address": {
    "@type": "PostalAddress",
    "streetAddress": "912, International Finance Center, VIP Road, Vesu",
    "addressLocality": "Surat",
    "addressRegion": "Gujarat",
    "postalCode": "395007",
    "addressCountry": "IN"
  },

  "sameAs": [
    "https://www.linkedin.com/company/onbbits",
    "https://www.instagram.com/onbbits_",
    "https://www.facebook.com/onbbits",
    "https://www.youtube.com/@Onbbits"
  ],

  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+91 97270 77732",
    "contactType": "customer support",
    "email": "info@onbbits.io",
    "areaServed": "IN",
    "availableLanguage": [
      "English"
    ]
  }
};

export default OrganizationSchema;